import { Routes } from '@angular/router';
import { AuthenticatedGuard } from '@core/guard/authenticated.guard';
import { LocationsGroupsComponent } from './locations-groups.component';
var ɵ0 = { title: 'CORE.SERVICES.NAVIGATION.LOCATIONS.GROUPS' };
var routes = [
    {
        path: 'localizacoes/grupos',
        pathMatch: 'full',
        component: LocationsGroupsComponent,
        canActivate: [AuthenticatedGuard],
        data: ɵ0
    }
];
var LocationsGroupsModule = /** @class */ (function () {
    function LocationsGroupsModule() {
    }
    return LocationsGroupsModule;
}());
export { LocationsGroupsModule };
export { ɵ0 };
